import styled from "@emotion/styled";
import { DataGrid } from "@mui/x-data-grid";

export const StyledDataGrid = styled(DataGrid)(() => ({
  "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
    outline: "none",
  },
  ".MuiDataGrid-cell:hover": {
    cursor: "pointer",
  },
  ".MuiDataGrid-columnHeaderTitleContainer:hover": {
    cursor: "auto",
  },
  "& .MuiDataGrid-columnHeaderTitleContainerContent div": {
    textShadow: "0px 0px 1px 2E133A",
    fontWeight: "700",
    fontSize: "14px",
    color: "#0d0d0d",
  },

  fontFamily: "Inter",
  fontSize: "14px",
  marginTop: "15px",
}));
